import React from 'react';
import { classes } from '../../../lib';

export type IconLabelProps = {
    icon: React.ReactNode;
    children: React.ReactNode;
    className?: string;
    style?: React.CSSProperties;
};

export const IconLabel = ({
    icon,
    children,
    className,
    style,
}: IconLabelProps): JSX.Element => {
    return (
        <span
            style={style}
            className={classes(className, 'horizontal left-middle g8 shrink')}>
            {icon}
            {children}
        </span>
    );
};
